import { Fragment } from "react";
import { DataTableShell } from "../common/DataTableShell";

const ProductDetails = ({ product }) => {
  if (!product) return null;

  return (
    <Fragment>
      <div className="ui-card" style={{ marginBottom: 16 }}>
        <h3 style={{ margin: "0 0 6px", fontSize: 15, fontWeight: 700 }}>Descripción corta</h3>
        <p style={{ margin: "0 0 16px", color: "#5A6187", fontSize: 13 }}>{product.shortDescription || "-"}</p>
        <h3 style={{ margin: "0 0 6px", fontSize: 15, fontWeight: 700 }}>Descripción larga</h3>
        <p style={{ margin: 0, color: "#5A6187", fontSize: 13 }}>{product.longDescription || "-"}</p>
      </div>

      <div className="ui-card">
        <h3 style={{ margin: "0 0 14px", fontSize: 15, fontWeight: 700 }}>Precios por país</h3>
        <DataTableShell
          minWidth={560}
          empty={!product.aditionalData || product.aditionalData.length === 0}
          emptyMessage="No hay precios registrados."
          headers={
            <>
              <th>País</th>
              <th style={{ textAlign: "right" }}>Precio local</th>
              <th style={{ textAlign: "right" }}>USDT</th>
              <th style={{ textAlign: "center" }}>Días</th>
              <th style={{ textAlign: "center" }}>Regalía</th>
              <th style={{ textAlign: "center" }}>Bono</th>
            </>
          }
        >
          {product.aditionalData?.map((item, idx) => (
            <tr key={idx}>
              <td style={{ fontWeight: 600 }}>{item.country_id?.name ?? "País desconocido"}</td>
              <td style={{ textAlign: "right", fontWeight: 600, whiteSpace: "nowrap" }}>${item.price_local_currency.toLocaleString()}</td>
              <td style={{ textAlign: "right", color: "#5A6187", whiteSpace: "nowrap" }}>{item.price_usdt} USDT</td>
              <td style={{ textAlign: "center", color: "#5A6187" }}>{item.delivery_time_days}</td>
              <td style={{ textAlign: "center", color: "#5A6187" }}>{item.loyalty_points}</td>
              <td style={{ textAlign: "center", color: "#5A6187" }}>{item.influencer_bonus}</td>
            </tr>
          ))}
        </DataTableShell>
      </div>
    </Fragment>
  );
};

export default ProductDetails;
